<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="schoolId">
                <span slot="label" ><a-tooltip>{{$t('学校')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-select show-search :filter-option="schoolFilter" :placeholder="$t('请选择')+$t('学校')" style="width: 100%" v-model="queryParam.schoolId" allowClear>
                  <a-select-option v-for="(item, index) in this.schoolList" :value="item.id+''" :key="index">
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="batchName">
                <span slot="label" ><a-tooltip>{{$t('批次名称')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.batchName" :maxLength="32" :placeholder="$t('请输入')+'批次名称'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="batchCode">
                <span slot="label" ><a-tooltip>{{$t('批次口令')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.batchCode" :maxLength="32" :placeholder="$t('请输入')+'批次口令'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item  prop="stage">
                <span slot="label" ><a-tooltip>{{$t('物流类型')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-select :placeholder="$t('请选择')+$t('物流类型')" style="width: 100%" v-model="queryParam.logisticsType" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.DeliveryTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item  prop="stage">
                <span slot="label" ><a-tooltip>{{$t('批次标签')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-select :placeholder="$t('请选择')+$t('批次标签')" style="width: 100%" v-model="queryParam.batchType" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.SchoolBatchTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item prop="mobile">
              <span slot="label" ><a-tooltip>{{$t('客服电话')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.mobile" :maxLength="32" :placeholder="$t('请输入')+'客服电话'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                   :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                   :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['school:schoolbatch:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" :school-list="schoolList" @ok="getList"/>
      <batch-qrcode ref="batchQrcode" />
      <school-grade-checkbox-select ref="schoolGradeCheckboxSelect" @gradeSelect="saveGrade" />
      <uniform-checkbox-select ref="uniformCheckboxSelect" @goodsSelect="saveGoods"></uniform-checkbox-select>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '1200' }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="logisticsType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.DeliveryTypeEnum" :color="true" :value="record.logisticsType"/>
        </span>
        <span slot="batchType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.SchoolBatchTypeEnum" :value="record.batchType"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-button type="link" size="small" @click="$refs.createForm.handleUpdate(record.id)" v-hasPermi="['school:schoolbatch:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a-button>
          <a-button  type="link" size="small" @click="handleGrade(record)">
             <a-icon type="add" />{{$t('添加班级')}}
          </a-button>
          <a-button  type="link" size="small" @click="handleBatchLog(record.id)" >
             {{$t('批次日志')}}
          </a-button>
          <br/>
<!--          <a-divider type="vertical"  />
          <a @click="handleGoods(record)">
             <a-icon type="add" />{{$t('批次商品')}}
          </a>-->
          <a-button  type="link" size="small" @click="handleAppQrCode(record)" >
            <a-icon type="qrcode" />{{$t('二维码')}}
          </a-button>
          <a-button  type="link" size="small" @click="handleMaQrCode(record)" >
            <a-icon type="qrcode" />{{$t('小程序码')}}
          </a-button>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageSchoolBatch,
  delSchoolBatch,
  getSchoolBatchQrcode,
  schoolBatchGradeList,
  schoolBatchGradeSave, schoolBatchGoodsList, schoolBatchGoodsSave
} from '@/api/school/schoolBatch'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {listSchool} from "@/api/school/school";
import BatchQrcode from './modules/BatchQrcode'
import SchoolGradeCheckboxSelect from '@/views/school/schoolGrade/select/SchoolGradeCheckboxSelect.vue'
import UniformCheckboxSelect from "@/views/goods/goods/select/UniformCheckboxSelect.vue";

export default {
  name: 'SchoolBatch',
  components: {
    UniformCheckboxSelect,
    CustomDictTag,
    CreateForm,
    BatchQrcode,
    SchoolGradeCheckboxSelect,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      schoolList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        batchName: undefined,
        batchCode: undefined,
        batchType: undefined,
        logisticsType: undefined,
        mobile: undefined,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('批次名称'),
          dataIndex: 'batchName',
          align: 'center'
        },
        {
          title: this.$t('学校口令'),
          dataIndex: 'batchCode',
          align: 'center'
        },
        {
          title: this.$t('批次标签'),
          dataIndex: 'batchType',
          scopedSlots: { customRender: 'batchType' },
          align: 'center'
        },
        {
          title: this.$t('物流类型'),
          dataIndex: 'logisticsType',
          scopedSlots: { customRender: 'logisticsType' },
          align: 'center'
        },
        /*{
          title: this.$t('公告内容'),
          dataIndex: 'notification',
          align: 'center'
        },*/
        {
          title: this.$t('开始时间'),
          dataIndex: 'startTime',
          align: 'center'
        },
        {
          title: this.$t('结束时间'),
          dataIndex: 'endTime',
          align: 'center'
        },
        {
          title: this.$t('学校'),
          dataIndex: 'schoolName',
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '24%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getRouteList()
    this.getSchoolList()
  },

  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    $route:'getRouteList'
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询学校批次列表 */
    getList () {
      this.loading = true
     pageSchoolBatch(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getRouteList() {
      let query = this.$route.query;
      if (query.schoolId) {
        this.queryParam.schoolId = query.schoolId
      }
      this.getList()
    },
    getSchoolList () {
      this.loading = true
      listSchool({}).then(response => {
        this.schoolList = response.data
      })
    },
    schoolFilter(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        batchName: undefined,
        batchCode: undefined,
        batchType: undefined,
        logisticsType: undefined,
        mobile: undefined,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleAppQrCode(row) {
      this.$refs.batchQrcode.handleAppQrCode(row)
    },
    handleMaQrCode(record) {
      getSchoolBatchQrcode({ "id": record.id }).then(response => {
        let base64 = ''
        if (response && response.data) {
          base64 = response.data
        } else if (response) {
          base64 = response
        }
        if (!base64) {
          this.$message.warning(this.$t('未获取到二维码'))
          return
        }
        const imageUrl = base64.indexOf('data:image') === 0 ? base64 : `data:image/png;base64,${base64}`
        this.$refs.batchQrcode.openMiniProgram(record, imageUrl)
      }).catch(() => {
        this.$message.error(this.$t('获取小程序二维码失败'))
      })
    },
    handleBatchLog(id) {
      this.$router.push({
        path: 'batch/change/log',
        query: {batchId: id}
      })
    },
    handleGrade(row) {
      //查询关联的id列表
      schoolBatchGradeList({"id":row.id}).then(response => {
        this.$refs.schoolGradeCheckboxSelect.openGoods(row.schoolId, row.id, response.data)
      })
    },
    saveGrade(batchId, records) {
      console.log("拿到班级, ",batchId, records)
      schoolBatchGradeSave({"id":batchId, "gradeIdList": records}).then(response => {
        if (response.code === '20001') {
          this.$message.success("添加班级成功", 3)
        }
      })
    },
    handleGoods(row) {
      //查询关联的id列表
      schoolBatchGoodsList({"id":row.id}).then(response => {
        this.$refs.uniformCheckboxSelect.openGoods(response.data, null, 21,row.id)
      })
    },
    saveGoods(batchId, records) {
      schoolBatchGoodsSave({"id":batchId, "goodsIdList": records}).then(response => {
        if (response.code === '20001') {
          this.$message.success("添加商品成功", 3)
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let reqData = {"idList":this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delSchoolBatch(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/school/batch/export',
            that.queryParam
          , `学校批次_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
